import { makeStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import red from '@material-ui/core/colors/red';

export const useStyles = makeStyles(() => ({
	samplesBasketWrapperMobile: {
		paddingBottom: 70	
	},
	deleteButton: {
		padding: 0,
		'&:hover': {
			background: 'none'
		}
	},
	deleteButtonIcon: {
		color: grey[500],
		'&:hover': {
			color: red[500]
		}
	},
	menuListItem: {
		fontSize: 14,
		padding: '15px 30px'
	},
	listItemIcon: {
		fontSize: 24
	},
	listItemText: {
		fontSize: 14
	},
	requestAllSamplesListItem: {
		justifyContent: 'center'
	},
	requestAllSamplesListItemIcon: {
		marginRight: 15,
		minWidth: 0
	},
	requestAllSamplesIcon: {
		fontSize: 22
	},
	requestAllSamplesListItemRoot: {
		flexGrow: 0
	}
}));